<template>
  <div>
    <!-- <spinner v-if="loading" /> !-->
    <div
      class="col-12 bid-ask-content p-0 mb-4"
      :class="{ 'in-arb-warning': offerIsInArb }"
    >
      <div class="row m-0 header">
        <!-- @click="openDropdown()" -->
        <div
          class="col-6 d-flex justify-content-center flex-nowrap align-items-center"
        >
          <h5 class="row my-0 text-center">
            <div style="margin-right: 5px">
              {{ !editOfferMode ? yourSideName : otherSideName }}
            </div>
            <div
              :class="{ 'spread-underline': leftUnderlineComputed }"
              @click="openDropdown()"
            >
              {{ !editOfferMode ? formattedBidNumber : formattedAskNumber }}
            </div>
          </h5>
        </div>
        <div
          class="col-6 d-flex justify-content-center flex-nowrap align-items-center"
        >
          <h5 class="row my-0 text-center">
            <div style="margin-right: 5px">
              {{ !editOfferMode ? otherSideName : yourSideName }}
            </div>
            <div
              :class="{ 'spread-underline': rightUnderlineComputed }"
            >
              {{ !editOfferMode ? formattedAskNumber : formattedBidNumber }}
            </div>
          </h5>
        </div>
      </div>
      <div class="row m-0 align-items-start" style="bmin-height: auto">
        <div
          v-if="bidLadderDisplay.length === 0"
          class="col-6 text-center p-0 align-self-center no-orders-available"
        >
          No orders available
        </div>
        <div v-else class="col-6 team-one p-0">
          <div
            v-for="(level, levInd) in bidLadderDisplay"
            :id="`${offerMode ? 'tbof' : 'tb'}-${level.id}`"
            :key="level.id"
            class="col-12 d-flex justify-content-center flex-nowrap align-items-center gutter position-relative"
            :class="{
              animated: selectedBidsHover.includes(level.id),
              scaled: selectedBidIds.includes(level.id),
              'user-orders':
                level.createdBy === userStore.user.id && !editOfferMode && userStore.user.isLoggedIn,
            }"
            @click="selectBids(levInd)"
            @mouseenter="selectBidsHover(levInd)"
            @mouseleave="resetBidsHover()"
          >
            <div
              v-if="!offerMode || (offerMode && offerIsInArb)"
              class="bg-selected-bid"
              :style="{ width: level.widthLadder }"
              @transitionend="widthLadderTransitionEnd(level.id)"
            />
            <div
              v-if="widthLadderRule(level) || offerMode"
              :id="`${offerMode ? 'bsof' : 'bs'}-${level.id}`"
              :class="{
                'background-stairs-left': (level.createdBy !== userStore.user.id) || !userStore.user.isLoggedIn,
                'background-stairs-left-own':
                  (level.createdBy === userStore.user.id) && userStore.user.isLoggedIn,
              }"
              :style="{
                width: sizeVolumeBar(level.id, 'bidLadder'),
              }"
            />
            <div class="row col-6 text-left px-1">
              <div class="d-inline ml-1">
                <div
                  class="numbers"
                  :class="{
                    line:
                      selectedBidIds.length > 0 &&
                      levInd === selectedBidIds.length - 1,
                  }"
                >
                  {{ formatLadderOdds(level.odds) }}
                </div>
              </div>
              <informational-tooltip
                v-if="(level.createdBy === userStore.user.id) && userStore.user.isLoggedIn"
                class="text-lowercase font-weight-light d-inline-flex"
                style="z-index: 5"
                :text-content="'how others see your existing offer'"
              />
            </div>
            <div
              class="col-6 text-right px-1 gutter username buy"
              :class="{
                strike:
                  offerMode &&
                  Object.prototype.hasOwnProperty.call(level, 'strike'),
              }"
            >
              ${{
                formatVolume(
                  level.cumulativeVolume || level.volume || level.vol,
                )
              }}
            </div>
          </div>
        </div>
        <div
          v-if="askLadderDisplay.length === 0"
          class="col-6 text-center p-0 align-self-center no-orders-available"
        >
          No orders available
        </div>

        <div v-else class="col-6 team-two p-0">
          <div
            v-for="(level, levelIx) in askLadderDisplay"
            :id="`${offerMode ? 'tbof' : 'tb'}-${level.id}`"
            :key="levelIx + bidLadder.length"
            :class="{
              'user-orders': (level.createdBy === userStore.user.id) && userStore.user.isLoggedIn,
              'current-offer': offerMode && level.isProspective,
            }"
            class="col-12 d-flex justify-content-center flex-nowrap align-items-center gutter"
          >
            <div
              :id="`${offerMode ? 'bsof' : 'bs'}-${level.id}`"
              :class="{
                'background-stairs-right':
                  (level.createdBy !== userStore.user.id) || !userStore.user.isLoggedIn,
              }"
              :style="{
                width: sizeVolumeBar(level.id, 'askLadder'),
              }"
            />
            <div class="col-6 text-left px-1 username sell gutter">
              ${{
                formatVolume(
                  level.cumulativeVolume || level.volume || level.vol,
                )
              }}
              <span v-if="offerMode && level.isProspective" class="othersSee">
                (Others See)</span
              >
              <informational-tooltip
                v-if="(level.createdBy === userStore.user.id) && userStore.user.isLoggedIn"
                class="text-lowercase font-weight-light d-inline-flex"
                :text-content="
                  offerMode && level.isProspective
                    ? 'How other users will see this offer'
                    : 'how others see your existing offer'
                "
              />
            </div>
            <div class="col-6 text-right px-1">
              <div class="numbers">
                {{ formatLadderOdds(level.odds) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BidAskShowMore
        v-if="showMoreComputed"
        :all="!showAllOrders"
        @show-more="showMore"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import InformationalTooltip from '@/components/global/tooltips/InformationalTooltip.vue';
import BidAskShowMore from '@/components/betting/BidAskShowMore.vue';
import { useUserStore } from '@/stores/user';
import { signOdds } from '@/core/utils';
import { formatOdds, formatOddsNoCommission } from '@/core/oddsFormatUtils';

const props = defineProps({
  fullGame: {
    type: Object,
    default: () => ({}),
  },
  side: {
    type: Object,
    default: () => ({}),
  },
  offerMode: {
    type: Boolean,
    default: false,
  },
  offer: {
    type: Object,
    default: () => ({}),
  },
  editOfferMode: {
    type: Boolean,
    required: false,
    default: false,
  },
  yourSideName: {
    type: String,
    required: false,
    default: '',
  },
  otherSideName: {
    type: String,
    required: false,
    default: '',
  },
  takeBetMode: {
    type: Boolean,
    required: false,
    default: false,
  },
  leftElements: {
    type: Array,
    required: false,
    default: () => [],
  },
  rightElements: {
    type: Array,
    required: false,
    default: () => [],
  },
  risk: {
    type: String,
    default: '',
  },
  selectedBidIds: {
    type: Array,
    default: () => [],
  },
  bidLadder: {
    type: Array,
    default: () => [],
  },
  askLadder: {
    type: Array,
    default: () => [],
  },
  spreadNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  totalNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  offerIsInArb: {
    type: Boolean,
    default: false,
    required: false,
  },
});

onMounted(() => {
  if (!props.offerMode || (props.offerMode && props.offerIsInArb)) {
    updateBidLadderWidth(props.risk ?? 0);
  }
  props.bidLadder.forEach((element) => {
    stairsVisibleArray.value.push({
      id: element.id,
      visible: true,
    });
  });
});

const emit = defineEmits(['selectBids', 'openDropdown', 'addWidthToBidLadder']);

watch(
  () => props.risk,
  (riskInput) => {
    if (!props.offerMode || (props.offerMode && props.offerIsInArb)) {
      updateBidLadderWidth(riskInput);
    }
  },
);

const userStore = useUserStore();
const showAllOrders = ref(false);
const selectedBidsHover = ref([]);
const stairsVisibleArray = ref([]);

/* below 2 values are true if there are alternative spreads or totals available
it then underlines it so user can select the alternate spread */

const leftUnderlineComputed = computed(() => {
  return props.takeBetMode && props.leftElements.length > 1;
});

const rightUnderlineComputed = computed(() => {
  // Only the selected side (left) should be clickable, not the other side
  return false;
});

// this emite an event to open the drop down to select alternate spreads
// Only opens when clicking the selected side (left side)
function openDropdown() {
  if (leftUnderlineComputed.value) {
    emit('openDropdown');
  }
}

function formatVolume(v) {
  const n = Number.parseFloat(v);
  const options =
    n <= 100
      ? {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      : {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        };
  return n.toLocaleString('en-US', options);
}

const bidLadderDisplay = computed(() => {
  if (props.bidLadder.length <= 3 || showAllOrders.value) {
    return props.bidLadder;
  } else {
    return props.bidLadder.slice(0, 3);
  }
});

const askLadderDisplay = computed(() => {
  if (props.askLadder.length <= 3 || showAllOrders.value) {
    return props.askLadder;
  } else {
    return props.askLadder.slice(0, 3);
  }
});

const formattedBidNumber = computed(() => {
  if (props.side.type === 'spread') {
    return `${signOdds(props.spreadNumber)}`;
  } else if (props.side.type === 'total') {
    return ` ${props.totalNumber}`;
  }
  return '';
});

const formattedAskNumber = computed(() => {
  if (props.side.type === 'spread') {
    return `${signOdds(-props.spreadNumber)}`;
  }
  return formattedBidNumber.value;
});

const askLadderSum = computed(() => {
  return props.askLadder.reduce(
    (total, valorActual) => parseFloat(total) + parseFloat(valorActual.volume),
    0,
  );
});

const bidLadderSum = computed(() => {
  return props.bidLadder.reduce(
    (total, valorActual) => parseFloat(total) + parseFloat(valorActual.volume),
    0,
  );
});

const showMoreComputed = computed(() => {
  if (props.bidLadder.length > 3 || props.askLadder.length > 3) {
    return true;
  }
  return false;
});

function widthLadderTransitionEnd(id) {
  if (!id || !stairsVisibleArray.value) {
    return;
  }
  const indexStairsArray = stairsVisibleArray.value.findIndex(
    (item) => item?.id === id,
  );
  if (indexStairsArray !== -1 && stairsVisibleArray.value[indexStairsArray]) {
    stairsVisibleArray.value[indexStairsArray].visible =
      !stairsVisibleArray.value[indexStairsArray].visible;
  }
}

function widthLadderRule(level) {
  return level.widthLadder == '0%' || level.widthLadder == undefined;
}

function formatLadderOdds(odds) {
  return formatOdds(
    odds,
    props.fullGame?.league.toLowerCase(),
    props.side?.type,
    true,
    userStore,
  );
}

function updateBidLadderWidth(riskInput) {
  let inputRiskValue = riskInput;
  let arrayWidthLadder = [];
  if (riskInput !== undefined && riskInput !== null) {
    for (let index = 0; index < props.bidLadder.length; index++) {
      if (inputRiskValue >= props.bidLadder[index].volume) {
        arrayWidthLadder.push('100%');
        inputRiskValue = inputRiskValue - props.bidLadder[index].volume;
      } else {
        arrayWidthLadder.push(
          Math.floor((inputRiskValue / props.bidLadder[index].volume) * 100) +
            '%',
        );
        index = props.bidLadder.length;
      }
    }
    emit('addWidthToBidLadder', arrayWidthLadder);
  }
}

// updated this function to just emit the selected orders
function selectBids(index) {
  // are these being added, or removed? aka is the index already there
  const id = props.bidLadder[index].id;
  let delivery;
  // if it already is selected
  if (props.selectedBidIds?.includes(id) && index !== 0) {
    // the new selected basket is everything one above this
    delivery = bidLadderDisplay.value.slice(0, index);
  } else {
    delivery = bidLadderDisplay.value.slice(0, index + 1);
  }
  // bundle up the selected bids to be sent to the take bet modal, only those that are selected
  emit('selectBids', delivery);
}

function selectBidsHover(index) {
  const bids = props.bidLadder.slice(0, index + 1);
  selectedBidsHover.value = bids.map((bid) => bid.id);
}

function resetBidsHover() {
  selectedBidsHover.value = [];
}

function sizeVolumeBar(id, ladder) {
  const bidOrAsk = ladder === 'bidLadder' ? 'bidLadder' : 'askLadder';
  if (bidOrAsk === 'bidLadder') {
    const index = props.bidLadder.findIndex((v) => v.id === id);
    const data = props.bidLadder.slice(0, index + 1);
    const sumVolume = data.reduce(
      (total, val) => parseFloat(total) + parseFloat(val.volume),
      0,
    );
    const width = `${(sumVolume / bidLadderSum.value) * 75}%`;
    return width;
  } else {
    const index = props.askLadder.findIndex((v) => v.id === id);
    const data = props.askLadder.slice(0, index + 1);
    const sumVolume = data.reduce(
      (total, val) => parseFloat(total) + parseFloat(val.volume),
      0,
    );
    const width = `${(sumVolume / askLadderSum.value) * 75}%`;
    return width;
  }
}

function showMore() {
  showAllOrders.value = !showAllOrders.value;
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/main.scss';

.strike {
  text-decoration: line-through;
}

.bid-ask-content {
  border-radius: 20px;
  border: 1px solid main.$grey-1500;
  overflow: hidden;
  color: main.$color-primary_01;
  font-weight: bold;
  box-shadow: 0 2px 10px 0 main.$blue-1200;
}

.team-one,
.team-two {
  > div {
    padding: 8px 6px;
    border-top: 1px solid main.$grey-1500;
    border-left: main.$transparent;
    border-right: main.$transparent;
    cursor: pointer;
    font-size: 0.95rem;

    @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
      font-size: 0.75rem;
    }

    > h5 {
      padding: 8px;
      color: main.$blue-1100;
    }
  }
}

.background-stairs-left {
  position: absolute;
  background-color: main.$grey-1300;
  height: 100%;
  right: 0;
}

.background-stairs-right {
  position: absolute;
  background-color: main.$blue-1500;
  height: 100%;
  left: 0;
}

.background-stairs-left-own {
  position: absolute;
  background-color: main.$transparent;
  height: 100%;
  right: 0;
}

.numbers {
  float: left;
  position: relative;
  font-weight: bold;
}

.team-two {
  background-color: main.$grey-200;

  .numbers {
    float: right;
    font-weight: bold;
  }
}

.header {
  background-color: main.$color-primary_02;
  color: main.$grey-500_01;
  padding: 8px 6px;

  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    font-size: 0.75rem;
  }
}

.user-orders {
  background-color: main.$green-200;
  color: main.$grey-500_01;
}

.current-offer {
  background-color: main.$green-200;
  color: main.$grey-500_01;
  .background-stairs-left,
  .background-stairs-right {
    background-color: transparent;
  }
}

/* When the offer is crossing the book and arb rest mode is OFF, the user sees
   a yellow "filled immediately" warning banner. Align the ladder highlight on
   their own order / prospective offer row with that same warning palette so
   the two visuals read as one. */
.bid-ask-content.in-arb-warning {
  .user-orders,
  .current-offer {
    background-color: #fff6e0;
    color: #8a6312;
  }
}

.bg-selected-bid {
  background-color: main.$grey-2100;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 1;
  opacity: 0.3;
  transition: width 0.5s ease;
}

.othersSee {
  font-size: x-small;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    display: none;
  }
}

.spread-underline {
  cursor: pointer;
  text-decoration: underline;
}

.animated,
.scaled {
  text-decoration: none;
  // "This row is clickable — tap to set your bet" highlight. Applied
  // cumulatively to the row and all rows above it (the depth you would fill).
  // `.animated` is the ephemeral hover affordance; `.scaled` is the persistent
  // highlight that stays once a row is selected, so the bettor keeps a visual
  // anchor on the depth they picked while they type their bet amount.
  // background-color + inset accent bar avoid any layout shift.
  background-color: main.$blue-1201;
  box-shadow: inset 3px 0 0 main.$blue-500;
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.line {
  cursor: pointer;
  z-index: 2;
  text-decoration: underline;
}

.no-orders {
  background-color: main.$grey-200;
}

.yourOffer {
  font-size: x-small;
  font-style: italic;
}

.no-orders-available {
  font-size: 16px;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    font-size: 12px;
  }
}
</style>
